<template>
  <div class="GrumePage">
    <div class="container">
      <div class="card shadow-lg p-4">

        <h2 class="text-center mb-4">Grumes</h2>

        <div class="row align-items-center">
          <div class="col-md-6 mb-3">
            <img src="@/assets/grumes.jpg" alt="Grumes" class="img-fluid rounded shadow " />
          </div>

          <div class="col-md-6">
            <p class="fs-5">
              Nous proposons des grumes issues exclusivement de nos forêts belges.<br>
              Avec un diamètre supérieur à <strong>50cm</strong>
              , elles ne peuvent être traitées par nos machines idéales pour les particuliers bien équipés ou les
              professionnels.<br>
            </p>

            <div class="alert alert-info mt-3">
              <strong>Les Livraisons sont possibles selon deux formules :</strong><br>
              <strong>Par tracteur :</strong> de 12 à 14 stères – dans un rayon de <strong>20 km</strong> autour de
              Perwez<br>
              <strong>Par camion :</strong> 50 à 55 stères – livraison partout en Belgique<br>
              <strong>Tarif :</strong> Contactez-nous pour une offre personnalisée<br>
            </div>
            <div class="col-md-12 text-center">
              <a href="/public/contact" class="btn btn-primary mt-3">
                Nous contacter
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: 'GrumePage',
  components: {
  }
}
</script>
